import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="loading-screen">
      <div className="loading-logo">
        Avivan <span>Enterprises</span>
      </div>
      <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '24px' }}>
        FMCG Distribution Partner
      </div>
      <div className="loading-bar">
        <div className="loading-bar-fill"></div>
      </div>
    </div>
  );
}
